import { Controller } from "@hotwired/stimulus";
import { normalizeText, smartMatch } from "../../utils/smart_search";

export default class extends Controller {
  static targets = ["input", "item", "list", "noResults"];

  connect() {
    this.filter();
  }

  filter() {
    // Smart search: every word, any order, partial, case and accents ignored.
    const query = normalizeText(this.inputTarget.value);
    let visibleCount = 0;

    this.itemTargets.forEach((item) => {
      const isMatch = smartMatch(item.dataset.searchable || "", query);

      if (isMatch) {
        item.classList.remove("hidden");
        visibleCount++;
      } else {
        item.classList.add("hidden");
      }
    });

    // Show the "no results" message when needed
    if (this.hasNoResultsTarget) {
      if (visibleCount === 0 && query !== "") {
        this.noResultsTarget.classList.remove("hidden");
      } else {
        this.noResultsTarget.classList.add("hidden");
      }
    }
  }
}
